<template>
  <v-container fluid>
    <div v-if="sectionHeaders != null">
      <page-bar title="Sections" />

      <div class="px-8 py-4">
        <v-row align="start" justify="start">
          <!-- Add New Section Card -->
          <card-section
            v-if="CanUserEditAssets()"
            :section="{ name: 'Add New' }"
            icon="mdi-plus"
            v-on:click="$router.push('section/create/wizard')"
          >
          </card-section>

          <!-- Existing Section Cards -->
          <card-section
            v-for="item in sectionHeaders"
            :key="item.id"
            v-bind:section="item"
            v-bind:imgUrl="item.thmUrl ? item.thmUrl + sasToken() : null"
            v-bind:icon="item.thmUrl ? null : 'mdi-folder'"
            :show-actions="CanUserEditAssets() && !item.isDefault"
            v-on:click="OnSectionPress(item.name)"
            @delete="onDeleteRequest"
          >
          </card-section>
        </v-row>
      </div>
    </div>
    <div v-else class="fill-height d-flex align-center justify-center">
      <Loading></Loading>
    </div>

    <!-- Delete Section Confirmation Dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="headline pt-6 px-6 pb-2">Delete section?</v-card-title>
        <v-card-text class="px-6 pb-4">
          Are you sure you want to delete
          <strong>{{ sectionToDelete ? sectionToDelete.name : '' }}</strong>?
          This cannot be undone.
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer />
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
          <v-btn color="red" text @click="confirmDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";

import CardSection from "../cards/CardSection";
import Loading from "../shared/Loading";
import PageBar from "../shared/PageBar";

import { mapGetters } from "vuex";

export default {
  name: "Section",
  components: {
    CardSection,
    Loading,
    PageBar,
  },
  props: {},
  computed: {
    ...mapState("assetxpstate", ["sectionHeaders"]),
  },
  mounted: function() {
    this.GetSectionHeaders();
  },
  data: () => ({
    showDeleteDialog: false,
    sectionToDelete: null,
  }),
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets", "sasToken"]),
    ...mapActions("assetxpstate", ["GetSectionHeaders", "RemoveSection"]),
    ...mapActions("navstate", ["GetSelectedSection"]),
    OnSectionPress(sectionName) {
      this.GetSelectedSection(sectionName);
      this.$router.push({
        name: "Section Search",
        params: { sectionName: sectionName },
      });
    },
    onDeleteRequest(section) {
      this.sectionToDelete = section;
      this.showDeleteDialog = true;
    },
    confirmDelete() {
      this.RemoveSection(this.sectionToDelete.id)
        .then(() => {
          this.showDeleteDialog = false;
          this.sectionToDelete = null;
          this.GetSectionHeaders();
        })
        .catch(() => {
          this.showDeleteDialog = false;
          this.sectionToDelete = null;
        });
    },
  },
};
</script>

<style></style>
